export default "<link rel=\"stylesheet\" type=\"text/css\" href=\"/front_mo/src/css/main.css\">"